export default __webpack_public_path__ + "static/media/032-transportation.fef04776.png";